import axios from 'axios'

const BASE_URL = 'https://api.brandzg.net/'

// const BASE_URL = '/api/'

export function get(url, params) {
    url = BASE_URL + url.replace(/^\//, '');
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then(res => {
            resolve(res.data);
        }).catch(err => {
            reject(err)
        })
    })
}


export function post(url, data) {
    url = BASE_URL + url.replace(/^\//, '');
    let form = new FormData()
    let keys = Object.keys(data)
    keys.forEach(key => {
        form.append(key, data[key])
    })
    return new Promise((resolve, reject) => {
        axios.post(url, form)
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}
